<template>
  <section class="grey_bg" aria-labelledby="upi-heading">
    <div class="container mt-4">
      <h1 id="upi-heading" class="display-1 page-title">
        <span class="heading_bdr_btm">
          SEBI-validated "@Valid" UPI handles
        </span>
      </h1>
      <div class="row">
        <div class="col-xs-12 col-md-8 col-md-offset-2">
          <h2 class="mt-4">About @Valid UPI</h2>
          <p>
            As per SEBI's recent directives, all SEBI-registered intermediaries, including Research Analysts, are required to adopt validated and exclusive UPI handles (@Valid UPI) for collecting payments. This initiative has been introduced to further enhance investor protection and ensure that your payments are always directed to verified SEBI-registered entities.
          </p>

          <p>
            As per the latest SEBI mandate, our new @Valid UPI ID for Research Services is now active:
          </p>

          <p class="text-center font-weight-bold">
            growwithstocks.ra@validicici
          </p>

          <div class="text-center mt-4 mb-4">
            <p><strong>QR code:</strong></p>
            <img :src="qrCodeImage" alt="GWS UPI QR Code" class="qr-code-img" />
          </div>

          <p class="mt-3">
            <strong>Please note:</strong>
          </p>
          <ul>
            <li>These @valid UPI IDs are only for payment towards research services, i.e. Recommended Stocks.</li>
            <li>You do NOT need to remember or note them down. We will provide you with these whenever you need to make a payment to us.</li>
            <li>These UPI IDs may change in future if we change our payment gateway provider or bank account.</li>
          </ul>

          <p class="mt-3">
            <strong>What this means for you:</strong>
          </p>
          <ul>
            <li>Whenever you make payments for our Research Services (Recommended Stocks) using UPI, you will now see the option to pay to our @Valid UPI handle.</li>
            <li>Other payment modes such as credit/debit cards, net banking, etc., also remain available as before.</li>
          </ul>

          <p class="mt-3">
            <strong>How to identify @Valid UPI:</strong>
          </p>
          <ul>
            <li>The UPI ID will contain @valid along with the bank name.</li>
            <li>On your payment confirmation screen, you will see a white thumbs-up icon inside a green triangle, which assures you that payment is being made to a verified SEBI-registered intermediary.</li>
          </ul>

          <p class="mt-3">
            <strong>SEBI Check:</strong> <a href="https://siportal.sebi.gov.in/intermediary/sebi-check" target="_blank" rel="noopener noreferrer">https://siportal.sebi.gov.in/intermediary/sebi-check</a>
          </p>

          <p>
            SEBI Check enables investors to verify the authenticity of UPI IDs and linked bank account details, either by scanning a QR code or manually entering the UPI ID. This will give you an additional and simple way to confirm that your payments are always directed to a genuine SEBI-registered intermediary.
          </p>

          <p>
            SEBI has made this initiative mandatory for all intermediaries to provide investors with a secure, verified and transparent payment experience.
          </p>

          <h2 class="mt-5">Frequently Asked Questions (FAQs) for Investors</h2>

          <h3 class="faq-question mt-3">Q. What is @Valid UPI?</h3>
          <p>
            @Valid UPI is a special, SEBI-validated UPI handle introduced for payments to SEBI-registered intermediaries. It assures investors that their payments are being made only to a genuine SEBI-registered entity.
          </p>

          <h3 class="faq-question mt-3">Q. Why is SEBI introducing @Valid UPI?</h3>
          <p>
            SEBI has mandated @Valid UPI to enhance safety, transparency, and trust in financial transactions. When you pay using a @Valid UPI handle, you can be confident that the funds are going to a verified SEBI-registered intermediary.
          </p>

          <h3 class="faq-question mt-3">Q. Is it compulsory for the investors to use the new handle only? Do I have to use @Valid UPI for all payments?</h3>
          <p>
            Investors can choose their preferred mode of payment, including UPI, Credit/Debit Cards, Net banking, IMPS, NEFT etc. However, if you pay via UPI for Research Services (Recommended stocks), it should be made only to the @Valid UPI handle.
          </p>

          <h3 class="faq-question mt-3">Q. Does @Valid UPI change my payment experience?</h3>
          <p>
            No. This is only a backend change. The payment process remains the same for you; there is no extra step or setup required.
          </p>

          <h3 class="faq-question mt-3">Q. What should I check while making a payment using the new UPI IDs/ QR Code?</h3>
          <p>
            Investors need to keep the following things in consideration:
          </p>
          <ul>
            <li>The UPI ID should properly show the name of the intermediary, followed by the short abbreviation of their category, for example, "ra" for Research Analysts, "brk" for Brokers, to the left of the "@" character.</li>
            <li>On the right side of the "@", the new and exclusive handle "@valid" should be present, followed by the bank name.</li>
            <li>On the confirmation screen, the app should show a white thumbs-up icon inside a green triangle.</li>
            <li>The QR code generated using the utility will have a white thumbs-up icon inside a green triangle. It will also display the UPI ID just below the QR code.</li>
          </ul>

          <h3 class="faq-question mt-3">Q. What is SEBI Check?</h3>
          <p>
            SEBI Check is a tool by SEBI that will allow you to:
          </p>
          <ul>
            <li>Verify whether a @Valid UPI ID truly belongs to a SEBI-registered intermediary.</li>
            <li>Confirm the linked bank account details before making a payment.</li>
          </ul>
          <p>
            You will be able to use SEBI Check either by scanning a QR code or by manually entering the UPI ID.
          </p>

          <h3 class="faq-question mt-3">Q. Do investors also need to obtain new UPI handles to transact in the securities market?</h3>
          <p>
            No, the new UPI IDs are only for intermediaries to obtain, and investors can continue to use their existing UPI IDs.
          </p>

          <h3 class="faq-question mt-3">Q. Whom to approach if my transaction/ payment fails with the new UPI ID?</h3>
          <p>
            The secure, validated UPI ID of intermediaries will use the same banking channel as the earlier generic UPI handles. In case of any technical difficulty, investors are requested to approach their respective banks.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "ValidUpi",
    mounted() {
      document.title = "Valid UPI Handles | Grow With Stocks";
    },
    data() {
      return {
        qrCodeImage: require("@/assets/gws-upi-qr-code.png")
      };
    }
  };
</script>

<style lang="scss" scoped>
  .page-title {
    text-align: center;
    color: #1a1a1a;
    font-weight: 700;
  }

  h2 {
    color: #1a1a1a;
    font-weight: 700;
    font-size: 22px;
    margin-top: 24px;
    margin-bottom: 12px;
  }

  /* WCAG 1.3.1 — FAQ questions exposed as <h3> while preserving the
     original "bold question" visual treatment. */
  .faq-question {
    color: #1a1a1a;
    font-weight: 700;
    font-size: 17px;
    line-height: 1.5;
    margin-bottom: 8px;
  }

  .grey_bg {
    background: #f7f7f7;
    padding-bottom: 40px;
  }

  ul {
    margin-top: 10px;
    margin-bottom: 15px;
  }

  li {
    margin-bottom: 8px;
  }

  a {
    color: #1a7055;
    text-decoration: underline;

    &:hover,
    &:focus {
      color: #0d3d2e;
    }
  }

  .qr-code-img {
    max-width: 300px;
    width: 100%;
    height: auto;
    border: 2px solid #ddd;
    border-radius: 8px;
    padding: 10px;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  @media only screen and (max-width: 480px) {
    .qr-code-img {
      max-width: 250px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ValidUpi.vue